// Importo React
import React, { FormEvent, useEffect, useState } from 'react';

// Material UI
import TextField from '@mui/material/TextField';

// Estilos globales
import '../styles/global_styles.css';

// Componentes
import Header from '../components/Header';
import ReCaptcha from '../components/ReCaptcha';
import DatePicker from '../components/DatePicker';
import CredencialModal from '../components/CredencialModal';

// Funciones
import VerificarSocioCredencial from '../functions/VerificarSocioCredencial';
import VerificarCaptcha from '../functions/VerificarCaptcha';
import isValidISODate from '../functions/IsValidISODate';
// Stores
import cotizadorStore from '../store/cotizador';
import globalStore from '../store/global';

const Credencial = () => {

    const [captchaValue, setCaptchaValue] = useState<string | null>(null);
    const [localDocumento, setLocalDocumento] = useState<string>('');
    const [localFechaNacimiento, setLocalFechaNacimiento] = useState<string>('');
    const [localFechaNacimientoValida, setLocalFechaNacimientoValida] = useState<boolean>(false);
    const [botonEnviar, setBotonEnviar] = useState<boolean>(true);
    const [formularioEnviado, setFormularioEnviado] = useState<boolean>(false);
    const [errorFormulario, setErrorFormulario] = useState<string>('');
    const [enDesarrollo, setEnDesarrollo] = useState<boolean>(true);

    const [verCredencial, setVerCredencial] = useState<boolean>(false);

    const [resetKey, setResetKey] = useState(0);

    const { seccion, setSeccion } = globalStore();

    const isValidDate = (): boolean => {
        const day = localFechaNacimiento.slice(8, 10);
        const month = localFechaNacimiento.slice(5, 7);
        const year = localFechaNacimiento.slice(0, 4);
        
        if (!day || !month || !year) return false;

        const months = [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
        ];
        
        const monthIndex = months.indexOf(month);
        
        if (monthIndex === -1) return false;
        
        const yearNum = parseInt(year);
        const dayNum = parseInt(day);
        
        if (isNaN(yearNum) || isNaN(dayNum)) return false;
        if (yearNum < 1 || yearNum > 9999) return false;
        if (dayNum < 1 || dayNum > 31) return false;
      
        // Crear la fecha
        const date = new Date(yearNum, monthIndex, dayNum);
 
        // Verificar si la fecha resultante coincide con la entrada
        if (date.getFullYear() === yearNum && 
            date.getMonth() === monthIndex && 
            date.getDate() === dayNum) {
          
          return true;
        }
      
        return false;
    };
    
    const navegarA = (destino: string) => {
        setSeccion(destino);
        let seccionElement = document.getElementById(destino);
        if (seccionElement === null) return;
        seccionElement.scrollIntoView({ behavior: 'smooth' });
    };
              
    const handleCaptchaChange = (value: string | null) => {
        setCaptchaValue(value);
    };

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // Lógica para enviar el formulario
        // Valido que el dni y la fecha de nacimiento sean válidos
        const dni = localDocumento;
        const fchnac = localFechaNacimiento;
        
        if (!enDesarrollo) {
            // Esto se ejecuta cuando el captcha está disponible en prod.
            const resultCaptchaVerification = await VerificarCaptcha(captchaValue || '');

            if (resultCaptchaVerification.error) {
                setErrorFormulario(resultCaptchaVerification.mensaje);
                return;
            }

            if (resultCaptchaVerification.captchaVerificado === false) {
                setErrorFormulario('Error al verificar el captcha');
                return;
            }

            if (resultCaptchaVerification.captchaVerificado === true) {
                
                if (dni.trim().length < 7) {
                    setFormularioEnviado(false);
                    setVerCredencial(false);
                    setErrorFormulario('Verifique el número de documento.');
                    return;
                }

                if (fchnac.length !== 10 || !isValidISODate(fchnac)) {
                    setFormularioEnviado(false);
                    setVerCredencial(false);
                    setErrorFormulario('Verifique la fecha de nacimiento.');
                    return;
                }
                const respuesta = await VerificarSocioCredencial(dni, fchnac);
                if (respuesta.socio_ok === 'si') {
                    setFormularioEnviado(true);
                    setVerCredencial(true);
                    setErrorFormulario('');
                } else {
                    setFormularioEnviado(false);
                    setVerCredencial(false);
                    setErrorFormulario(respuesta.mensaje);
                }
            } else {
                setFormularioEnviado(false);
                setVerCredencial(false);
                setErrorFormulario('Error al verificar el captcha');
            }
        } else {
            // Esta parte se ejecuta si estamos en desarrollo (para evitar el procesamiento del captcha)
            
            if (dni.trim().length < 7) {
                setFormularioEnviado(false);
                setVerCredencial(false);
                setErrorFormulario('Verifique el número de documento.');
                return;
            }

            if (fchnac.length !== 10 || !isValidISODate(fchnac)) {
                setFormularioEnviado(false);
                setVerCredencial(false);
                setErrorFormulario('Verifique la fecha de nacimiento.');
                return;
            }
            const respuesta = await VerificarSocioCredencial(dni, fchnac);
            if (respuesta.socio_ok === 'si') {
                setFormularioEnviado(true);
                setVerCredencial(true);
                setErrorFormulario('');
            } else {
                setFormularioEnviado(false);
                setVerCredencial(false);
                setErrorFormulario(respuesta.mensaje);
            }
        }
    };

    const handleDocumentoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalDocumento(event.target.value);
    };

    const handleFechaNacChange = (date: string) => {
        setLocalFechaNacimiento(date);  
    };

    const handleReset = () => {
        setLocalDocumento('');
        setLocalFechaNacimiento('');
        setCaptchaValue(null);
        setErrorFormulario('');
        setBotonEnviar(false);
        setResetKey(prev => prev + 1);
    };

    const checkFechaNacIsValid = (isValid: boolean) => {
        setLocalFechaNacimientoValida(isValid);
    };

    const reiniciarFormulario = () => {
        setErrorFormulario('');
        setVerCredencial(false);
        setLocalDocumento('');
        setLocalFechaNacimiento('');
        setBotonEnviar(false);
        setFormularioEnviado(false);
    };

    
    useEffect(() => {
        if (enDesarrollo) {
            setBotonEnviar(true);
        } else {
            if (captchaValue) {
                if (localDocumento.trim().length >= 7) {
                    if (isValidDate()) {
                        setBotonEnviar(true)
                    } else {
                        setBotonEnviar(false)
                    }
                } else {
                    setBotonEnviar(false)
                }
            } else {
                setBotonEnviar(false)
            }
        }
    }, [captchaValue, localDocumento, localFechaNacimiento]);


    return (
    <div className="flex flex-col h-full">
        <Header navegacionFija={false} seccionActual={'cotizador'} cambiarSeccion={navegarA}></Header>
        {!formularioEnviado &&
            (<div className="flex flex-col justify-center items-center h-full mt-8">
                <div className='flex flex-col justify-center items-center border-2 rounded-lg border-vp-azul shadow shadow-vp-gris'>
                    <div className='bg-vp-azul w-full'>
                        <h1 className='font-metropolis text-2xl text-white py-4 text-center'>Generá tu Credencial</h1>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="flex flex-col justify-center items-start p-2 space-y-4">
                            <div className="flex flex-row w-full items-center justify-start space-x-3">
                                <div className="w-[80px]">
                                    <h1 className="">Nro. D.N.I.</h1>
                                </div>
                                <div>
                                    <TextField id="documento" label="Documento" variant="outlined" value={localDocumento} onChange={handleDocumentoChange}
                                        sx={{
                                            '& .MuiOutlinedInput-input': {
                                                paddingY: '16px',
                                            },
                                            width: '110px',
                                            textAlign: 'center',
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-row w-full items-center justify-start space-x-3">
                                <div className="w-[80px]">
                                    <h1 className="">Fecha Nac.</h1>
                                </div>
                                <div>
                                    <DatePicker key={resetKey} etiqueta="" initialDate={localFechaNacimiento} onDateChange={handleFechaNacChange} onDateValid={checkFechaNacIsValid}/>
                                </div>
                            </div>
                            {!enDesarrollo && (
                            <div className="flex flex-row flex-grow w-full items-center justify-start">
                                <ReCaptcha onChange={handleCaptchaChange} />
                            </div>)}
                            <div className="flex flex-row w-full items-center justify-center space-x-3">
                                <button type="button" className="vp-btn-rojo" onClick={handleReset}>Reestablecer</button>
                                <button type="submit" className="vp-btn-azul" disabled={!botonEnviar}>Generar</button>
                            </div>
                            {errorFormulario && (
                                <div className="flex flex-row w-full items-center justify-center">
                                    <p className="text-red-500">{errorFormulario}</p>
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        )}
        {formularioEnviado && (
            <CredencialModal nroDocumento={localDocumento || ''} isVisible={verCredencial} setIsVisible={reiniciarFormulario} />
        )}
    </div>
    );
};

export default Credencial;